/* GSN Labs — sélecteur d'offre de la fiche produit.
   Relie les options d'achat au formulaire du thème :
     · écrit l'identifiant du forfait dans le champ `selling_plan` ;
     · règle la quantité pour l'option volume ;
     · reporte le prix choisi sur le bouton d'ajout au panier.
   Aucune option n'invente de prix : tout vient des attributs `data-prix`
   calculés en Liquid à partir des données de la boutique. */
(function () {
  'use strict';

  function formaterPrix(centimes, format) {
    var valeur = (centimes / 100).toFixed(2).replace('.', ',');
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, valeur);
    }
    return valeur + ' €';
  }

  function initialiser(racine) {
    if (racine.dataset.gsnPret === 'oui') return;
    racine.dataset.gsnPret = 'oui';

    var formId = racine.dataset.form;
    var formulaire = formId ? document.getElementById(formId) : null;
    var champPlan = racine.querySelector('[data-gsn-plan]');
    var format = racine.dataset.moneyFormat || '';
    var options = Array.prototype.slice.call(racine.querySelectorAll('input[type="radio"]'));
    if (!options.length) return;

    var champSecours = racine.querySelector('[data-gsn-qty]');

    /* Le champ de secours n'existe que pour les gabarits sans selecteur de
       quantite. Si le theme en fournit un, on le desactive : deux champs
       `quantity` dans le meme formulaire donneraient une quantite imprevisible. */
    function champQuantite() {
      var candidats = [];
      if (formulaire) candidats = candidats.concat(
        Array.prototype.slice.call(formulaire.querySelectorAll('input[name="quantity"]'))
      );
      candidats = candidats.concat(
        Array.prototype.slice.call(document.querySelectorAll('input[name="quantity"][form="' + formId + '"]'))
      );
      var duTheme = candidats.filter(function (c) {
        return !c.hasAttribute('data-gsn-qty');
      });
      if (duTheme.length) {
        if (champSecours) champSecours.disabled = true;
        return duTheme[0];
      }
      if (champSecours) champSecours.disabled = false;
      return champSecours;
    }

    function boutonAjout() {
      if (!formulaire) return null;
      return formulaire.querySelector('.product-form__submit, button[type="submit"]');
    }

    function appliquer(option) {
      if (!option) return;

      racine.querySelectorAll('.gsn-opt').forEach(function (carte) {
        carte.classList.toggle('is-active', carte.contains(option));
      });

      if (champPlan) champPlan.value = option.dataset.plan || '';

      var quantite = champQuantite();
      if (quantite) {
        quantite.value = option.dataset.qty || '1';
        quantite.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var prix = parseInt(option.dataset.prix, 10);
      if (isNaN(prix)) return;
      var libelle = formaterPrix(prix, format);

      var bouton = boutonAjout();
      if (bouton) {
        var suffixe = bouton.querySelector('[data-gsn-atc-suffixe]');
        if (!suffixe) {
          suffixe = document.createElement('span');
          suffixe.setAttribute('data-gsn-atc-suffixe', '');
          var cible = bouton.querySelector('span:not(.svg-wrapper):not([hidden])') || bouton;
          cible.appendChild(suffixe);
        }
        suffixe.textContent = ' — ' + libelle;
      }

      var doses = parseInt(option.dataset.doses, 10);
      var resume = racine.parentNode && racine.parentNode.querySelector('[data-gsn-resume]');
      if (resume && doses > 0) {
        resume.innerHTML = 'soit <strong>' + formaterPrix(Math.round(prix / doses), format) + ' la dose</strong>';
      }
    }

    options.forEach(function (option) {
      option.addEventListener('change', function () { appliquer(option); });
    });

    appliquer(options.filter(function (o) { return o.checked; })[0] || options[0]);
  }

  /* Le lien « Voir l'etiquette et les dosages » n'a pas de cible propre : il
     ouvre l'accordeon nutritionnel de la fiche et l'amene sous les yeux. Si
     aucun accordeon ne correspond, le lien ne fait rien plutot que de sauter
     en haut de page. */
  function brancherLienEtiquette() {
    var liens = document.querySelectorAll('.gsn-args__lien');
    if (!liens.length) return;

    var motsCles = ['valeur nutrition', 'valeurs nutritives', 'composition', 'etiquette', 'étiquette', 'dosage'];
    var cible = null;
    var titres = document.querySelectorAll('summary, .accordion__title, [class*="collapsible"] h2, [class*="collapsible"] h3');
    for (var i = 0; i < titres.length && !cible; i++) {
      var texte = (titres[i].textContent || '').toLowerCase();
      for (var j = 0; j < motsCles.length; j++) {
        if (texte.indexOf(motsCles[j]) !== -1) { cible = titres[i]; break; }
      }
    }
    if (!cible) return;

    liens.forEach(function (lien) {
      if (lien.dataset.gsnBranche === 'oui') return;
      lien.dataset.gsnBranche = 'oui';
      lien.setAttribute('href', '#');
      lien.addEventListener('click', function (evt) {
        evt.preventDefault();
        var details = cible.closest('details');
        if (details) details.open = true;
        else cible.click();
        cible.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* Compteur de galerie : indique combien de visuels restent a voir, pour que
     le client sache qu'il peut faire defiler. L'element actif est determine par
     ce qui occupe reellement le cadre, pas par un index suppose. */
  function compteurGalerie() {
    var liste = document.querySelector('.product__media-list');
    if (!liste) return;
    var cadre = liste.closest('.product__media-wrapper') || liste.parentElement;
    if (!cadre || cadre.querySelector('[data-gsn-compteur]')) return;

    var vignettes = liste.querySelectorAll('.product__media-item');
    if (vignettes.length < 2) return;

    cadre.classList.add('gsn-galerie');
    var badge = document.createElement('span');
    badge.setAttribute('data-gsn-compteur', '');
    badge.className = 'gsn-galerie__compteur';
    cadre.appendChild(badge);

    var total = vignettes.length;
    var courant = 1;
    function ecrire() {
      badge.textContent = courant + ' / ' + total + (courant === 1 ? ' — fais défiler' : '');
    }
    ecrire();

    if (!('IntersectionObserver' in window)) return;
    var vigie = new IntersectionObserver(function (entrees) {
      var meilleure = null;
      entrees.forEach(function (e) {
        if (!meilleure || e.intersectionRatio > meilleure.intersectionRatio) meilleure = e;
      });
      if (meilleure && meilleure.intersectionRatio > 0.5) {
        var idx = Array.prototype.indexOf.call(vignettes, meilleure.target);
        if (idx >= 0 && idx + 1 !== courant) { courant = idx + 1; ecrire(); }
      }
    }, { root: liste, threshold: [0.5, 0.75, 1] });
    Array.prototype.forEach.call(vignettes, function (v) { vigie.observe(v); });
  }

  function balayer() {
    document.querySelectorAll('[data-gsn-offre]').forEach(initialiser);
    brancherLienEtiquette();
    compteurGalerie();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', balayer);
  } else {
    balayer();
  }

  /* Le thème redessine la zone d'achat au changement de variante. */
  document.addEventListener('variant:change', balayer);
  document.addEventListener('shopify:section:load', balayer);
})();
